import React from "react";
import { overlay, img, active } from "./style.module.css";
import { usePromiseTracker } from "react-promise-tracker";

const Loader = () => {
    const { promiseInProgress  } = usePromiseTracker();
    return (
        <div className={`${overlay} ${promiseInProgress ? active : ``}`}>
            {promiseInProgress ? <img src={require("./puff.svg").default} alt="" className={img} /> : ""}
        </div>
    );
}

export default Loader;
